// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface BulkGetReactionsRequest {
    /**
     * The &#x60;reacted_to&#x60; transaction id(s) of the reactions in question.
     */
    reactedToIds: Array<string>;
    /**
     * The type of reactions for which to query.
     */
    type?: string;
}

/**
 * 
 */
export class ReactionsApi extends runtime.BaseAPI {

}
